export const SECTOR_COLORS: Record<string, string> = {
  "Technology": "hsl(262, 80%, 55%)",
  "Healthcare": "hsl(160, 70%, 45%)",
  "Financial Services": "hsl(35, 85%, 55%)",
  "Consumer Cyclical": "hsl(330, 70%, 55%)",
  "Industrials": "hsl(200, 60%, 50%)",
  "Communication Services": "hsl(15, 80%, 55%)",
  "Consumer Defensive": "hsl(85, 60%, 45%)",
  "Energy": "hsl(45, 90%, 50%)",
  "Real Estate": "hsl(280, 50%, 55%)",
  "Basic Materials": "hsl(180, 55%, 45%)",
  "Utilities": "hsl(120, 40%, 50%)",
};

export function getSectorColor(sector: string | undefined, isDark: boolean): { fill: string; stroke: string } {
  if (!sector) {
    return {
      fill: isDark ? "hsl(230, 40%, 30%)" : "hsl(220, 60%, 95%)",
      stroke: isDark ? "hsl(230, 50%, 55%)" : "hsl(220, 60%, 55%)",
    };
  }
  const base = SECTOR_COLORS[sector] || `hsl(${Math.abs(sector.split("").reduce((a, c) => a + c.charCodeAt(0), 0)) % 360}, 60%, 50%)`;
  const hueMatch = base.match(/hsl\((\d+)/);
  const hue = hueMatch ? parseInt(hueMatch[1]) : 200;
  return {
    fill: isDark ? `hsl(${hue}, 45%, 28%)` : `hsl(${hue}, 70%, 92%)`,
    stroke: isDark ? `hsl(${hue}, 60%, 55%)` : `hsl(${hue}, 65%, 45%)`,
  };
}
